export default "/images/vendor/flag-icon-css/flags/1x1/ug.svg?9e26c8f2269d749b4d2dfa46bf5355d4";